import React from 'react'
import styles from './style.module.scss'

export const Switch = ({onChange, checked = false}) => {
  if ( !onChange )
    console.warn("WARNING: Usage of a changeable form component (Switch) without onChange property.")

  return (
    <div className={styles['switch']}>
      <input type="checkbox" id="should_interact" onChange={onChange} checked={checked}/>
      <label htmlFor="should_interact"></label>
    </div>
  )
}